module.exports = __webpack_public_path__ + "static/media/mia-khalifa-lesb.f9fd5565.jpg";